import { createContext } from "react";
import type { User } from "./authentication.type";

export interface AuthContextProps {
  isPending: boolean;
  profile: User | null;
  isLoggedIn: boolean;
  login: (user: User | undefined) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);
